import { createFlags, StaticBackend } from "flag";

import { getFeatureFlags } from "../api/featureFlags";

export const OKP_HIDE_PASSWORD_BASED_LOGIN = "okp_hide_password_based_login";
export const OKP_INQUIRY_FLOW = "okp_api_and_inquiry";
export const BANK_INQUIRY_V2 = "bank_inquiry_v2";

const REVERSE_FLAGS = [OKP_HIDE_PASSWORD_BASED_LOGIN];

export type FeatureFlagsType = {
  [OKP_INQUIRY_FLOW]: boolean;
  [OKP_HIDE_PASSWORD_BASED_LOGIN]: boolean;
};

export const flagsStatus = async (featureFlags: string[]) => {
  const {
    data: { data }
  } = await getFeatureFlags(featureFlags);

  return data.reduce((acc: any, input: any) => {
    acc[input.id] = input.attributes.state === "on";

    if (REVERSE_FLAGS.includes(input.id)) {
      acc[input.id] = !acc[input.id];
    }

    return acc;
  }, {});
};

const { FlagBackendProvider, Flag, useFlag } = createFlags<FeatureFlagsType>();

export { Flag, FlagBackendProvider, StaticBackend, useFlag };
